//@flow
import React, {createContext, useMemo} from 'react';
import {TABLE_CELLS} from '../constants';
import {useActiveCellsId} from '../utils';

import type {TableCell} from '../constants';

const TableCellContext = createContext<TableCell[]>([]);

type Props = {
  children: React$Node,
};

export function TableCellProvider({children}: Props) {
  const activeCellsId = useActiveCellsId();

  const cells = useMemo(() => {
    return TABLE_CELLS.filter(({id}) => activeCellsId.includes(id));
  }, [activeCellsId]);

  return (
    <TableCellContext.Provider value={cells}>
      {children}
    </TableCellContext.Provider>
  );
}

export function useTableCells(): TableCell[] {
  return React.useContext(TableCellContext);
}
